export default "__VITE_ASSET__CNdUQv1I__"